export const msalConfig = {
    auth: {
        clientId: "ac5a7cfd-aefd-4038-8ee9-d8b5ab49d3fb",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: "/",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};
